// extracted by mini-css-extract-plugin
export default {"badgeGreen":"styles_badgeGreen__npygH","badgeRed":"styles_badgeRed__C1Ukb","selectedRow":"styles_selectedRow__YztCK"};